
import { createClient } from '@supabase/supabase-js';

// Helper to support Next.js, Vite, Expo and standard process.env
const getEnvVar = (key: string) => {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
    // @ts-ignore
    return import.meta.env[key];
  }
  return '';
};

// Credentials from your screenshot
const supabaseUrl = getEnvVar('NEXT_PUBLIC_SUPABASE_URL') || 'https://cuqitetvtjnlafgdwtyx.supabase.co';
const supabaseKey = getEnvVar('NEXT_PUBLIC_SUPABASE_ANON_KEY') || 'sb_publishable_K4cGP1ZoYT10JoNrXFOEqQ_H-C7Q9dt';

export const supabase = createClient(supabaseUrl, supabaseKey);

export const isSupabaseConfigured = () => {
  return supabaseUrl !== 'https://your-project.supabase.co';
};

// Types for our Database
export type MessageRow = {
  id: number;
  content: string;
  user_id: string;
  created_at: string;
  contact_id?: string;
};
